import React, { useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import "./IsoCertificateBatch.css";

export default function IsoCertificateBatch() {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="iso-badge-container">
      <div className="iso-glass" onMouseEnter={() => setShowDialog(true)} onMouseLeave={() => setShowDialog(false)}>
        <BsInfoCircle className="iso-icon" />
        <span>An ISO Certified Company</span>
      </div>

      {/* Dialog Box */}
      {showDialog && (
        <div className="iso-dialog">
          <div className="iso-dialog-header">
            <h4>ISO Certifications</h4>
            <AiOutlineClose className="close-icon" onClick={() => setShowDialog(false)} />
          </div>
          <ul>
            <li>✅ ISO 9001:2015 - Quality Management</li>
           
          </ul>
        </div>
      )}
    </div>
  );
}
